(() => {
  const initStickyBuy = (root = document) => {
    root.querySelectorAll('[data-sua-sticky-buy]').forEach((bar) => {
      if (bar.dataset.suaReady === 'true') return;
      bar.dataset.suaReady = 'true';

      const stickyButton = bar.querySelector('[data-sua-sticky-submit]');
      const targetId = bar.dataset.target;
      let observer;

      const getPrimaryButton = () => document.getElementById(targetId);

      const sync = () => {
        const primaryButton = getPrimaryButton();
        if (!primaryButton || !stickyButton) return;
        stickyButton.disabled = primaryButton.disabled;
        const primaryLabel = primaryButton.querySelector('span');
        const stickyLabel = stickyButton.querySelector('span');
        if (primaryLabel && stickyLabel) {
          stickyLabel.textContent = primaryLabel.textContent.trim();
        }
      };

      const observePrimaryButton = () => {
        const primaryButton = getPrimaryButton();
        if (!primaryButton) return;
        observer?.disconnect();
        observer = new IntersectionObserver(
          ([entry]) => {
            const show = !entry.isIntersecting && window.scrollY > 280;
            bar.classList.toggle('is-visible', show);
            bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          },
          { threshold: 0.15 }
        );
        observer.observe(primaryButton);
        sync();
      };

      stickyButton?.addEventListener('click', () => {
        const primaryButton = getPrimaryButton();
        if (primaryButton && !primaryButton.disabled) primaryButton.click();
      });

      document.addEventListener('change', (event) => {
        if (event.target.closest('product-info')) {
          window.setTimeout(() => {
            observePrimaryButton();
            sync();
          }, 120);
        }
      });

      observePrimaryButton();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyBuy());
  } else {
    initStickyBuy();
  }

  document.addEventListener('shopify:section:load', (event) => initStickyBuy(event.target));
})();
